(function () {
  'use strict';

  if (window.BGSelfHostedMyDesigns) return;

  function text(value) {
    return String(value || '').trim();
  }

  function escapeHtml(value) {
    return text(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  // "yard-signs-3d-preview-testing" → "yard signs 3d preview testing" for the
  // poster alt text; the list only knows the product handle.
  function humanizeProductLabel(value) {
    var label = text(value).replace(/[-_]+/g, ' ').replace(/\s+/g, ' ').trim();
    return label || 'this product';
  }

  // Bounded, non-PII telemetry (P-22): surface name only, through the existing
  // storefront client when the page loads it. Never a URL, id, or artwork fact.
  function emitMockupPosterRendered() {
    var telemetry = window.BGDesignerTelemetry;
    if (!telemetry || typeof telemetry.emitEvent !== 'function') return;
    try {
      telemetry.emitEvent('product_preview_poster_rendered', 'product-preview', { pageSurface: 'my_designs' }, 'low');
    } catch (error) {
      /* telemetry must never affect the gallery */
    }
  }

  function toIso(value) {
    var parsed = Date.parse(text(value));
    return Number.isFinite(parsed) ? new Date(parsed).toISOString() : '';
  }

  function formatDate(value) {
    var isoValue = toIso(value);
    if (!isoValue) return 'Unknown';
    try {
      return new Intl.DateTimeFormat('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
        hour: 'numeric',
        minute: '2-digit'
      }).format(new Date(isoValue));
    } catch (_) {
      return isoValue;
    }
  }

  var UNTITLED_DESIGN_LABEL = 'Untitled design';

  // MY-DESIGNS-RAW-LOOKUP-LABEL: the one rule for every name this page shows a
  // customer (the card, its preview, the product picker and the copy notices).
  // A name is words a person gave: the design's title and its template's
  // title. A value that only repeats one of the design's own keys (its
  // project, public, template or legacy lookup, or its product id) is no name;
  // the storefront app sent the public id as the title of a design saved
  // without one until 2026-10-02, and copies made before then can still carry
  // it in their stored name. A design with no name reads "Untitled design",
  // as Studio, Admin and the gallery name it; a template with no name has no
  // line.
  function readDesignLabels(item) {
    var source = item && typeof item === 'object' ? item : {};
    var keys = [
      source.id,
      source.lookup,
      source.projectId,
      source.publicId,
      source.legacyProjectId,
      source.legacyDesignId,
      source.templateLookup,
      source.productId
    ].map(function (value) {
      return text(value).toLowerCase();
    }).filter(Boolean);
    function plainName(value) {
      var name = text(value);
      return name && keys.indexOf(name.toLowerCase()) === -1 ? name : '';
    }
    return {
      title: plainName(source.title) || UNTITLED_DESIGN_LABEL,
      templateTitle: plainName(source.templateTitle)
    };
  }

  function normalizeItem(rawItem) {
    var item = rawItem && typeof rawItem === 'object' ? rawItem : {};
    var boardPreviews = Array.isArray(item.boardPreviews) ? item.boardPreviews : [];
    var selection = item.selection && typeof item.selection === 'object' ? item.selection : {};
    return {
      id: text(item.id || item.lookup || item.projectId),
      lookup: text(item.lookup || item.publicId || item.projectId || item.id),
      sourceType: text(item.sourceType || 'self-hosted') || 'self-hosted',
      projectId: text(item.projectId),
      publicId: text(item.publicId),
      legacyProjectId: text(item.legacyProjectId),
      legacyDesignId: text(item.legacyDesignId),
      designNumber: text(item.designNumber),
      title: text(item.title) || UNTITLED_DESIGN_LABEL,
      status: text(item.status) || 'saved',
      templateTitle: text(item.templateTitle),
      updatedAt: text(item.updatedAt),
      previewUrl: text(item.previewUrl || (boardPreviews[0] && boardPreviews[0].url)),
      boardPreviews: boardPreviews,
      // 3D preview Slice 7: present only while the api judges the poster current
      // for this design; the card falls back to previewUrl otherwise.
      mockupPoster: item.mockupPoster && typeof item.mockupPoster === 'object' && text(item.mockupPoster.url)
        ? {
          url: text(item.mockupPoster.url),
          width: Number(item.mockupPoster.width) || 0,
          height: Number(item.mockupPoster.height) || 0,
          fingerprint: text(item.mockupPoster.fingerprint)
        }
        : null,
      // MD-04: the api says a preview is still being made for this design. The
      // card shows a preparing state and the page polls until it arrives.
      previewPending: item.previewPending === true
        && !text(item.previewUrl || (boardPreviews[0] && boardPreviews[0].url))
        && !(item.mockupPoster && typeof item.mockupPoster === 'object' && text(item.mockupPoster.url)),
      productId: text(item.productId),
      productHandle: text(item.productHandle),
      templateLookup: text(item.templateLookup),
      selection: {
        selectedSizeId: text(selection.selectedSizeId),
        selectedSizeLabel: text(selection.selectedSizeLabel),
        selectedWidth: selection.selectedWidth == null ? null : Number(selection.selectedWidth),
        selectedHeight: selection.selectedHeight == null ? null : Number(selection.selectedHeight),
        selectedUnit: text(selection.selectedUnit),
        selectedOrientation: text(selection.selectedOrientation),
        size: text(selection.size),
        unfoldedSize: text(selection.unfoldedSize),
        backer: text(selection.backer),
        optionSelections: Array.isArray(selection.optionSelections) ? selection.optionSelections : []
      },
      hasOrderBinding: item.hasOrderBinding === true || text(item.hasOrderBinding).toLowerCase() === 'true',
      // The design's canvas has its own shape (a product surface). An unstated
      // flag (an older storefront app) reads as a plain design, which keeps
      // today's behavior: shaped products are hidden and the server judges.
      hasProductSurface: item.hasProductSurface === true,
      // A server resize (a resized copy, an in-place fit) scaled the artwork
      // and it has not been saved from the editor since; the card says so.
      needsResizeCheck: text(item.resizeReviewStatus) === 'needs-review',
      // TEMPLATE-EDIT-ORDERS-01: the design team is editing this ordered
      // design; the card is view-only until the proof is sent (the server
      // refuses the editor launch and the save as well). An unstated state
      // (an older storefront app) reads as editable.
      teamEditing: text(item.templateEditStatus) === 'in_progress',
      // MY-DESIGNS-UNSHARE-CONTROL-01: the design has a live share link. The
      // card then offers Copy link (the link itself, with no new request, so
      // the link the customer already sent out stays valid) and Stop sharing.
      // An unstated state (an older storefront app) reads as not shared.
      shareStatus: text(item.shareStatus) === 'active' ? 'active' : '',
      shareUrl: text(item.shareStatus) === 'active' ? text(item.shareUrl) : '',
      // MY-DESIGNS-SHAPED-ORDER-404-01: the storefront app says the design's
      // own product no longer takes an order (draft, deleted or unpublished).
      // Only that state removes Order; an unstated or unjudged state keeps it.
      productUnavailable: text(item.productAvailability) === 'unavailable',
      // MY-DESIGNS-PICKER-UNBOUND-SIZE-01: the artwork's own size, which the
      // picker judges a design by when its saved selection names no dimensions
      // (a design started without a product), exactly as the server does.
      boardSize: readBoardSize(item.boardSize),
      reason: text(item.reason),
      shopifyOrderId: text(item.shopifyOrderId)
    };
  }

  // TEMPLATE-EDIT-ORDERS-01: the one sentence a view-only card carries while
  // the design team edits an ordered design (the same sentence the server
  // answers an editor launch or save with).
  var TEAM_EDITING_MESSAGE = 'Our design team is working on this design. You can edit it after we send your proof.';

  // MD-04: preview polling. Internal constants, no Admin control. The page
  // polls only while a card is waiting for its preview: about every 3-5
  // seconds, until a wall-clock deadline of about 90 seconds per wait, never
  // while the tab is hidden, and no single request may run past 10 seconds.
  var PREVIEW_POLL_DELAYS_MS = [3000, 3000, 4000, 4000, 5000];
  var PREVIEW_POLL_BUDGET_MS = 90000;
  var PREVIEW_POLL_REQUEST_TIMEOUT_MS = 10000;

  function previewPollDelay(attempt) {
    return PREVIEW_POLL_DELAYS_MS[Math.min(attempt, PREVIEW_POLL_DELAYS_MS.length - 1)];
  }

  // One owner for the preview area of a card, shared by the full render and
  // the poll's in-place patch.
  function buildPreviewMarkup(item) {
    var previewUrl = text(item.previewUrl);
    var mockupPosterUrl = text(item.mockupPoster && item.mockupPoster.url);
    var productLabel = text(item.productHandle || item.productId) || 'Not bound';
    if (mockupPosterUrl) {
      return '<img src="' + escapeHtml(mockupPosterUrl) + '" alt="' + escapeHtml('3D preview of your design on ' + humanizeProductLabel(productLabel)) + '" title="Illustrative preview" loading="lazy">';
    }
    if (previewUrl) {
      return '<img src="' + escapeHtml(previewUrl) + '" alt="' + escapeHtml(readDesignLabels(item).title) + '" loading="lazy">';
    }
    if (item.previewPending) {
      return '<div class="bg-account-my-designs__preview-fallback" data-bg-preview-pending="true">Preparing preview…</div>';
    }
    return '<div class="bg-account-my-designs__preview-fallback">Preview unavailable</div>';
  }

  function buildProductUrl(productHandle, lookup) {
    var handle = text(productHandle);
    if (!handle) return '';
    var targetUrl = new URL('/products/' + handle.replace(/^\/+/, ''), window.location.origin);
    targetUrl.searchParams.set('bg_saved_project_id', text(lookup));
    targetUrl.searchParams.set('bg_saved_source', 'my-designs');
    targetUrl.searchParams.set('bg_saved_return', window.location.pathname);
    return targetUrl.toString();
  }

  // MD-03: product and size facts for the product modal. A product carries the
  // compact size list of its own configuration; nothing here knows a product
  // by name or id.
  function normalizeProductSize(raw) {
    var size = raw && typeof raw === 'object' ? raw : {};
    var width = Number(size.width);
    var height = Number(size.height);
    if (!text(size.id) || !(width > 0) || !(height > 0)) return null;
    return { id: text(size.id), label: text(size.label), width: width, height: height, unit: text(size.unit) };
  }

  function normalizeProduct(raw) {
    var product = raw && typeof raw === 'object' ? raw : {};
    var imageUrl = text(product.imageUrl);
    return {
      productId: text(product.productId),
      handle: text(product.handle),
      title: text(product.title) || humanizeProductLabel(product.handle),
      imageUrl: /^https:\/\//i.test(imageUrl) ? imageUrl : '',
      imageAlt: text(product.imageAlt),
      sizes: (Array.isArray(product.sizes) ? product.sizes : []).map(normalizeProductSize).filter(Boolean),
      defaultSize: normalizeProductSize(product.defaultSize),
      // A product whose configuration needs its own production layout takes
      // no saved design. A list that does not state the flag (an older
      // storefront app) still offers the product; the server refuses.
      acceptsCopies: product.acceptsCopies !== false,
      // A quarter turn counts as a fit only when the product says so; an
      // unstated flag means no turn, so the page is never looser than the server.
      allowRotate: product.allowRotate === true,
      // A product whose configuration gives the canvas its own shape takes
      // only a design started under it. An unstated flag (an older storefront
      // app) still offers the product; the server refuses.
      hasProductSurface: product.hasProductSurface === true
    };
  }

  function formatSizeLabel(size) {
    if (!size) return '';
    if (text(size.label)) return text(size.label);
    var unit = text(size.unit);
    return String(size.width) + ' x ' + String(size.height) + (unit ? ' ' + unit : '');
  }

  function readBoardSize(raw) {
    var size = raw && typeof raw === 'object' ? raw : {};
    var width = Number(size.width);
    var height = Number(size.height);
    if (!(width > 0) || !(height > 0)) return null;
    return { width: width, height: height, unit: text(size.unit) };
  }

  // The size a saved design was made at: its saved selection when it names
  // dimensions, else the artwork itself (a design started without a product
  // has no selection), else whatever the selection names, the way the server
  // judges a bind or a copy.
  function readDesignSize(item) {
    var selection = item && item.selection && typeof item.selection === 'object' ? item.selection : {};
    var width = Number(selection.selectedWidth);
    var height = Number(selection.selectedHeight);
    var label = text(selection.selectedSizeLabel || selection.size);
    if (width > 0 && height > 0) {
      return { label: label, width: width, height: height, unit: text(selection.selectedUnit) };
    }
    var board = readBoardSize(item && item.boardSize);
    if (board) {
      return { label: '', width: board.width, height: board.height, unit: board.unit };
    }
    if (!label) return null;
    return { label: label, width: 0, height: 0, unit: text(selection.selectedUnit) };
  }

  // Physical units compare in inches; any other unit compares as written,
  // the way the server and the editor launch do.
  var INCHES_PER_UNIT = { inches: 1, feet: 12, mm: 1 / 25.4, cm: 1 / 2.54 };

  function comparableDimensions(width, height, unit, otherUnit) {
    var factor = INCHES_PER_UNIT[text(unit).toLowerCase()];
    var otherFactor = INCHES_PER_UNIT[text(otherUnit).toLowerCase()];
    if (!factor || !otherFactor || factor === otherFactor) return { width: width, height: height };
    return { width: width * factor, height: height * factor };
  }

  function dimensionsNear(left, right) {
    return Math.abs(left - right) < 0.01;
  }

  // The server's size grammar (findMatchingProductSize in the api; the
  // precedent is reorderChooserSizeSignalsMatch on the product page): when
  // both sides state dimensions they must be equal within 0.01, as drawn, or
  // turned a quarter turn on a product that allows the turn. A label alone
  // decides only when one side states no dimensions. The server has the last
  // word when the customer chooses.
  function sizeFitsDesign(designSize, size, allowRotate) {
    if (!designSize || !size) return false;
    if (!(designSize.width > 0 && designSize.height > 0) || !(size.width > 0 && size.height > 0)) {
      var designLabel = text(designSize.label).toLowerCase();
      return Boolean(designLabel) && designLabel === text(size.label).toLowerCase();
    }
    var design = comparableDimensions(designSize.width, designSize.height, designSize.unit, size.unit);
    var product = comparableDimensions(size.width, size.height, size.unit, designSize.unit);
    var same = dimensionsNear(design.width, product.width) && dimensionsNear(design.height, product.height);
    var rotated = allowRotate === true && dimensionsNear(design.width, product.height) && dimensionsNear(design.height, product.width);
    return same || rotated;
  }

  function findFittingSize(designSize, product) {
    var sizes = product && Array.isArray(product.sizes) ? product.sizes : [];
    var allowRotate = Boolean(product && product.allowRotate === true);
    for (var index = 0; index < sizes.length; index += 1) {
      if (sizeFitsDesign(designSize, sizes[index], allowRotate)) return sizes[index];
    }
    return null;
  }

  var PICKER_SIZE_LINE_LIMIT = 3;

  function summarizeProductSizes(product) {
    var sizes = product && Array.isArray(product.sizes) ? product.sizes : [];
    if (!sizes.length) return '';
    var shown = sizes.slice(0, PICKER_SIZE_LINE_LIMIT).map(formatSizeLabel).join(', ');
    return sizes.length > PICKER_SIZE_LINE_LIMIT
      ? shown + ' and ' + String(sizes.length - PICKER_SIZE_LINE_LIMIT) + ' more'
      : shown;
  }

  // A small rendition is enough for the 56 px thumbnail box.
  function buildThumbnailUrl(imageUrl) {
    try {
      var parsed = new URL(imageUrl);
      if (!parsed.searchParams.has('width')) parsed.searchParams.set('width', '160');
      return parsed.toString();
    } catch (_) {
      return imageUrl;
    }
  }

  function buildProductThumbMarkup(product) {
    var initial = text(product.title).charAt(0).toUpperCase() || '?';
    var fallback = '<span class="bg-account-my-designs__picker-thumb-fallback" aria-hidden="true">' + escapeHtml(initial) + '</span>';
    if (!product.imageUrl) {
      return '<span class="bg-account-my-designs__picker-thumb">' + fallback + '</span>';
    }
    return '<span class="bg-account-my-designs__picker-thumb">' + fallback +
      '<img src="' + escapeHtml(buildThumbnailUrl(product.imageUrl)) + '" alt="' + escapeHtml(product.imageAlt) + '" width="56" height="56" loading="lazy" decoding="async" data-bg-picker-thumb-image>' +
      '</span>';
  }

  function initRoot(root) {
    var core = window.BGDesignerStorefrontCore;
    if (!core || !root) return null;

    var proxyRoot = text(root.getAttribute('data-proxy-root')) || '/apps/qps-commerce-control-plane/designer';
    var searchInput = root.querySelector('[data-bg-my-designs-search]');
    var refreshButton = root.querySelector('[data-bg-my-designs-refresh]');
    var summaryNode = root.querySelector('[data-bg-my-designs-summary]');
    var noticeNode = root.querySelector('[data-bg-my-designs-notice]');
    var listNode = root.querySelector('[data-bg-my-designs-list]');
    var paginationNode = root.querySelector('[data-bg-my-designs-pagination]');
    var searchTimer = 0;
    // One bounded telemetry fact per page visit, however often the list re-renders.
    var posterRenderedEmitted = false;
    var state = {
      items: [],
      party: null,
      total: 0,
      limit: 12,
      offset: 0,
      query: '',
      loading: false,
      products: null,
      productsPromise: null
    };

    // Navigation seam: the event lets the page (and tests) observe where the
    // customer is sent before the browser leaves.
    function navigateTo(url) {
      var target = text(url);
      if (!target) return false;
      try {
        root.dispatchEvent(new CustomEvent('bg-my-designs:navigate', { detail: { url: target } }));
      } catch (_) {}
      try {
        window.location.assign(target);
      } catch (_) {}
      return true;
    }

    function buildLoginUrl() {
      var loginTarget = text(root.getAttribute('data-login-url')) || '/account/login';
      var loginUrl = new URL(loginTarget, window.location.origin);
      loginUrl.searchParams.set('return_url', window.location.pathname);
      try {
        var currentUrl = new URL(window.location.href, window.location.origin);
        var previewThemeId = text(currentUrl.searchParams.get('preview_theme_id'));
        if (previewThemeId) loginUrl.searchParams.set('preview_theme_id', previewThemeId);
      } catch (_) {}
      return loginUrl.toString();
    }

    function redirectToLogin() {
      window.location.assign(buildLoginUrl());
      return false;
    }

    // The launch must name the platform store and a REAL product: the page
    // used to launch with its own page name as the product handle, which the
    // server could not resolve, so Edit died silently. The store key comes
    // from the section (brand config) or the theme's storefront global.
    var storeKey = text(root.getAttribute('data-store-key')) || text(window.storefront);
    var editorShell = core.createEditorShell({
      config: {
        handle: '',
        storeKey: storeKey,
        runtimeVersion: 'designer-my-designs-v1',
        designer: {
          proxyRoot: proxyRoot
        }
      },
      source: 'my-designs',
      overlayId: 'bg-my-designs-editor-shell',
      loadingCopy: 'Loading saved design…',
      onProjectSaved: function () {
        void loadLibrary('editor-save');
      },
      onClose: function () {
        void loadLibrary('editor-close');
      }
    });

    function setNotice(message, tone) {
      if (!noticeNode) return;
      var cleanMessage = text(message);
      noticeNode.hidden = !cleanMessage;
      noticeNode.className = 'bg-account-my-designs__notice' + (tone ? (' is-' + tone) : '');
      noticeNode.textContent = cleanMessage;
    }

    function requestJson(url, options) {
      return fetch(url, Object.assign({
        credentials: 'same-origin',
        headers: {
          accept: 'application/json'
        }
      }, options || {})).then(function (response) {
        return response.json().catch(function () {
          return null;
        }).then(function (payload) {
          if (response.status === 401 || text(payload && payload.error).toLowerCase() === 'login required') {
            redirectToLogin();
            throw new Error('Login required.');
          }
          if (!response.ok || !payload || payload.ok !== true) {
            throw new Error(text(payload && payload.error) || 'Request failed.');
          }
          return payload;
        });
      });
    }

    function renderSummary(detail) {
      if (!summaryNode) return;
      var party = detail && detail.party && typeof detail.party === 'object' ? detail.party : null;
      var total = Number(detail && detail.total) || 0;
      var serviceCount = Array.isArray(detail && detail.serviceAssignments) ? detail.serviceAssignments.length : 0;
      var lastUpdated = party && party.lastProjectUpdatedAt ? formatDate(party.lastProjectUpdatedAt) : 'No saved designs yet';
      summaryNode.innerHTML = '' +
        '<div class="bg-account-my-designs__stat"><strong>' + escapeHtml(String(total)) + '</strong><span>Saved designs</span></div>' +
        '<div class="bg-account-my-designs__stat"><strong>' + escapeHtml(String(serviceCount)) + '</strong><span>Open service edits</span></div>' +
        '<div class="bg-account-my-designs__stat"><strong>' + escapeHtml(lastUpdated) + '</strong><span>Last updated</span></div>';
    }

    function renderPagination() {
      if (!paginationNode) return;
      if (state.total <= state.limit) {
        paginationNode.hidden = true;
        paginationNode.innerHTML = '';
        return;
      }
      var start = state.offset + 1;
      var end = Math.min(state.offset + state.limit, state.total);
      paginationNode.hidden = false;
      paginationNode.innerHTML = '' +
        '<button type="button" class="button button--secondary" data-bg-page-prev' + (state.offset <= 0 ? ' disabled' : '') + '>Previous</button>' +
        '<span>Showing ' + escapeHtml(String(start)) + '–' + escapeHtml(String(end)) + ' of ' + escapeHtml(String(state.total)) + '</span>' +
        '<button type="button" class="button button--secondary" data-bg-page-next' + (end >= state.total ? ' disabled' : '') + '>Next</button>';
      var prev = paginationNode.querySelector('[data-bg-page-prev]');
      var next = paginationNode.querySelector('[data-bg-page-next]');
      if (prev) {
        prev.addEventListener('click', function () {
          state.offset = Math.max(0, state.offset - state.limit);
          void loadLibrary('prev-page');
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          state.offset = state.offset + state.limit;
          void loadLibrary('next-page');
        });
      }
    }

    function renderItems() {
      if (!listNode) return;
      if (state.loading) {
        listNode.innerHTML = '<div class="bg-account-my-designs__empty">Loading your saved designs…</div>';
        return;
      }
      if (!state.items.length) {
        listNode.innerHTML = '<div class="bg-account-my-designs__empty">No saved designs yet. Start a design from any product page and it will appear here.</div>';
        return;
      }
      listNode.innerHTML = state.items.map(function (item) {
        var mockupPosterUrl = text(item.mockupPoster && item.mockupPoster.url);
        var badgeClass = item.sourceType === 'legacy'
          ? ' is-legacy'
          : (item.sourceType === 'service-assignment' ? ' is-service' : ' is-self-hosted');
        var bindingActionLabel = item.hasOrderBinding ? 'Order' : 'Choose Product';
        var productLabel = text(item.productHandle || item.productId) || 'Not bound';
        var labels = readDesignLabels(item);
        return '' +
          '<article class="bg-account-my-designs__card" data-bg-my-design-id="' + escapeHtml(item.id) + '">' +
            '<div class="bg-account-my-designs__preview"' + (mockupPosterUrl ? ' data-bg-mockup-poster="true"' : '') + '>' +
              buildPreviewMarkup(item) +
            '</div>' +
            '<div class="bg-account-my-designs__body">' +
              '<div class="bg-account-my-designs__meta">' +
                '<span class="bg-account-my-designs__badge' + badgeClass + '">' + escapeHtml(item.sourceType === 'legacy' ? 'Legacy' : (item.sourceType === 'service-assignment' ? 'Service Edit' : 'Self-hosted')) + '</span>' +
                (item.designNumber ? '<span class="bg-account-my-designs__badge">#' + escapeHtml(item.designNumber) + '</span>' : '') +
              '</div>' +
              '<h2 class="bg-account-my-designs__title">' + escapeHtml(labels.title) + '</h2>' +
              (item.teamEditing ? '<p class="bg-account-my-designs__mark is-team" data-bg-team-editing>' + escapeHtml(TEAM_EDITING_MESSAGE) + '</p>' : '') +
              (item.needsResizeCheck ? '<p class="bg-account-my-designs__mark" data-bg-resize-check>Check the resized artwork</p>' : '') +
              '<div class="bg-account-my-designs__details">' +
                '<div><strong>Updated</strong><span>' + escapeHtml(formatDate(item.updatedAt)) + '</span></div>' +
                '<div><strong>Product</strong><span>' + escapeHtml(productLabel) + '</span></div>' +
                (labels.templateTitle ? '<div><strong>Template</strong><span>' + escapeHtml(labels.templateTitle) + '</span></div>' : '') +
              '</div>' +
              '<div class="bg-account-my-designs__actions">' + buildActionsMarkup(item) + '</div>' +
            '</div>' +
          '</article>';
      }).join('');
      if (!posterRenderedEmitted && listNode.querySelector('[data-bg-mockup-poster="true"]')) {
        posterRenderedEmitted = true;
        emitMockupPosterRendered();
      }
      bindCardActions(listNode);
    }

    function buildActionsMarkup(item) {
      // TEMPLATE-EDIT-ORDERS-01: a design the team is editing offers no
      // action; the card's own sentence says why and when that changes.
      if (item.teamEditing) return '';
      var bindingActionLabel = item.hasOrderBinding ? 'Order' : 'Choose Product';
      // MY-DESIGNS-SHAPED-ORDER-404-01: a design whose own product is gone
      // says so where Order was, instead of opening a page that is a 404;
      // Edit, Duplicate and Share stay.
      var orderMarkup = item.hasOrderBinding && item.productUnavailable
        ? '<p class="bg-account-my-designs__actions-note" data-bg-product-unavailable>This product is no longer available.</p>'
        : '<button type="button" class="button button--secondary" data-bg-action-order="' + escapeHtml(item.id) + '" aria-haspopup="dialog">' + escapeHtml(bindingActionLabel) + '</button>';
      return '' +
        '<button type="button" class="button" data-bg-action-edit="' + escapeHtml(item.id) + '">Edit</button>' +
        orderMarkup +
        (item.sourceType === 'legacy' ? '' : '<button type="button" class="button button--secondary" data-bg-action-duplicate="' + escapeHtml(item.id) + '">Duplicate</button>') +
        (item.sourceType === 'legacy' ? '' : buildShareActionsMarkup(item));
    }

    // MY-DESIGNS-UNSHARE-CONTROL-01: a design that is not shared offers Share.
    // A shared design offers its link (Copy link) and Stop sharing; the stop
    // action exists only while the design is shared.
    function buildShareActionsMarkup(item) {
      if (item.shareStatus !== 'active') {
        return '<button type="button" class="button button--secondary" data-bg-action-share="' + escapeHtml(item.id) + '">Share</button>';
      }
      return '' +
        '<span class="bg-account-my-designs__share">' +
          '<button type="button" class="button button--secondary" data-bg-action-share="' + escapeHtml(item.id) + '">Copy link</button>' +
          '<button type="button" class="button button--secondary" data-bg-action-unshare="' + escapeHtml(item.id) + '">Stop sharing</button>' +
        '</span>';
    }

    function bindCardActions(scope) {
      if (!scope) return;
      Array.prototype.slice.call(scope.querySelectorAll('[data-bg-action-edit]')).forEach(function (button) {
        button.addEventListener('click', function () {
          var itemId = text(button.getAttribute('data-bg-action-edit'));
          var item = state.items.find(function (entry) { return entry.id === itemId; });
          if (item) {
            void openEditorForItem(item, { trigger: button });
          }
        });
      });
      Array.prototype.slice.call(scope.querySelectorAll('[data-bg-action-order]')).forEach(function (button) {
        button.addEventListener('click', function () {
          var itemId = text(button.getAttribute('data-bg-action-order'));
          var item = state.items.find(function (entry) { return entry.id === itemId; });
          if (item) {
            void orderItem(item, { trigger: button });
          }
        });
      });
      Array.prototype.slice.call(scope.querySelectorAll('[data-bg-action-duplicate]')).forEach(function (button) {
        button.addEventListener('click', function () {
          var itemId = text(button.getAttribute('data-bg-action-duplicate'));
          var item = state.items.find(function (entry) { return entry.id === itemId; });
          if (item) {
            void duplicateItem(item, button);
          }
        });
      });
      Array.prototype.slice.call(scope.querySelectorAll('[data-bg-action-share]')).forEach(function (button) {
        button.addEventListener('click', function () {
          var itemId = text(button.getAttribute('data-bg-action-share'));
          var item = state.items.find(function (entry) { return entry.id === itemId; });
          if (item) {
            void shareItem(item, button);
          }
        });
      });
      Array.prototype.slice.call(scope.querySelectorAll('[data-bg-action-unshare]')).forEach(function (button) {
        button.addEventListener('click', function () {
          var itemId = text(button.getAttribute('data-bg-action-unshare'));
          var item = state.items.find(function (entry) { return entry.id === itemId; });
          if (item) {
            void unshareItem(item, button);
          }
        });
      });
    }

    // After a share state change, only that card's action row is redrawn (the
    // list, focus and the other cards stay put) and focus moves to the action
    // that replaced the one just used.
    function refreshCardActions(item, focusSelector) {
      if (!listNode) return;
      var card = listNode.querySelector('[data-bg-my-design-id="' + item.id + '"]');
      var actions = card ? card.querySelector('.bg-account-my-designs__actions') : null;
      if (!actions) return;
      actions.innerHTML = buildActionsMarkup(item);
      bindCardActions(actions);
      var next = focusSelector ? actions.querySelector(focusSelector) : null;
      if (next && typeof next.focus === 'function') next.focus();
    }

    // The list carries the link in full; an older storefront app may hand
    // over the share path alone, which the page completes with its own origin.
    function resolveShareUrl(item) {
      var url = text(item && item.shareUrl);
      if (!url) return '';
      if (/^https?:\/\//i.test(url)) return url;
      return url.charAt(0) === '/' ? text(window.location.origin) + url : '';
    }

    function copyShareLink(shareUrl) {
      if (!shareUrl) return Promise.resolve(false);
      if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
        return navigator.clipboard.writeText(shareUrl).then(function () {
          return true;
        }).catch(function () {
          return false;
        });
      }
      return Promise.resolve(false);
    }

    function shareItem(item, button) {
      var knownUrl = item.shareStatus === 'active' ? resolveShareUrl(item) : '';
      if (knownUrl) {
        // Copy link: the design is already shared, so the existing link is
        // copied as is (a new share request would replace the link and break
        // the copies the customer already sent out).
        if (button) button.disabled = true;
        return copyShareLink(knownUrl).then(function (copied) {
          setNotice(copied ? 'Share link copied to clipboard.' : 'Share link: ' + knownUrl, 'success');
        }).then(function () {
          if (button) button.disabled = false;
        });
      }
      setNotice('Creating a share link…', '');
      if (button) button.disabled = true;
      return resolveCanonicalLookup(item).then(function (lookup) {
        return requestJson(proxyRoot + '/my-designs/share', {
          method: 'POST',
          headers: {
            accept: 'application/json',
            'content-type': 'application/json'
          },
          body: JSON.stringify({ projectId: lookup })
        });
      }).then(function (payload) {
        var share = payload && payload.share && typeof payload.share === 'object' ? payload.share : {};
        var shareUrl = text(share.url);
        return copyShareLink(shareUrl).then(function (copied) {
          if (shareUrl && copied) {
            setNotice('Share link copied to clipboard.', 'success');
          } else if (shareUrl) {
            setNotice('Share link: ' + shareUrl, 'success');
          } else {
            setNotice('Share link created.', 'success');
          }
          // The design is shared now: its card offers the link and Stop sharing.
          if (button) button.disabled = false;
          item.shareStatus = 'active';
          item.shareUrl = shareUrl;
          refreshCardActions(item, '[data-bg-action-share]');
        });
      }).catch(function (error) {
        if (button) button.disabled = false;
        setNotice(text(error && error.message) || 'Could not create a share link.', 'error');
      });
    }

    // The one way a card says its design is not shared: the card returns to
    // Share in place, focus moves there and one notice confirms it.
    function showItemNotShared(item, button) {
      if (button) button.disabled = false;
      item.shareStatus = '';
      item.shareUrl = '';
      refreshCardActions(item, '[data-bg-action-share]');
      setNotice('This design is no longer shared.', 'success');
    }

    function isItemListed(item) {
      return !state.loading && state.items.indexOf(item) !== -1;
    }

    // MY-DESIGNS-STALE-SHARE-TAB-01: after a refused Stop sharing the card
    // follows the server, never the refusal (the revoke lane answers one
    // sentence for "already off" and for a real failure alike). The page reads
    // the list page it is showing once more, with the same request the list
    // loader and the preview poll send, and looks the design up in it. Only an
    // item the server itself states as not shared (`shareStatus` present and
    // empty) answers true. A design that is still shared, is missing from the
    // page or appears twice, an unstated state, and a refused, failed, unreadable
    // or stalled read all answer false, and the card stays as it is. The read
    // redirects nowhere and runs no longer than one preview poll request may.
    function readServerSaysNotShared(item) {
      return new Promise(function (resolve) {
        var controller = typeof AbortController === 'function' ? new AbortController() : null;
        var settled = false;
        var requestTimer = 0;
        function finish(notShared) {
          if (settled) return;
          settled = true;
          window.clearTimeout(requestTimer);
          resolve(notShared === true);
        }
        requestTimer = window.setTimeout(function () {
          if (controller) {
            try { controller.abort(); } catch (_) {}
          }
          finish(false);
        }, PREVIEW_POLL_REQUEST_TIMEOUT_MS);
        try {
          var requestOptions = { credentials: 'same-origin', cache: 'no-store', headers: { accept: 'application/json' } };
          if (controller) requestOptions.signal = controller.signal;
          fetch(buildLibraryRequestUrl(), requestOptions).then(function (response) {
            if (!response.ok) return null;
            return response.json().catch(function () { return null; });
          }).then(function (payload) {
            var detail = payload && payload.ok === true && payload.detail && typeof payload.detail === 'object' ? payload.detail : null;
            var matches = (detail && Array.isArray(detail.items) ? detail.items : []).filter(function (raw) {
              return !!item.id && normalizeItem(raw).id === item.id;
            });
            finish(matches.length === 1 && matches[0].shareStatus === '');
          }).catch(function () {
            finish(false);
          });
        } catch (_) {
          finish(false);
        }
      });
    }

    // Stop sharing: turns the design's share link off through the storefront
    // app's revoke lane. On success the card returns to Share and one notice
    // confirms it. After a refusal the page asks the server for the design's
    // share state (the link may have been turned off in another tab): a design
    // the server states as not shared returns to Share the same way; anything
    // else keeps the card as it was with the server sentence.
    function unshareItem(item, button) {
      setNotice('Turning off the share link…', '');
      if (button) button.disabled = true;
      return resolveCanonicalLookup(item).then(function (lookup) {
        return requestJson(proxyRoot + '/my-designs/share/revoke', {
          method: 'POST',
          headers: {
            accept: 'application/json',
            'content-type': 'application/json'
          },
          body: JSON.stringify({ projectId: lookup })
        });
      }).then(function () {
        showItemNotShared(item, button);
      }).catch(function (error) {
        var refusal = text(error && error.message) || 'Could not stop sharing this design.';
        function keepCard() {
          if (button) button.disabled = false;
          setNotice(refusal, 'error');
        }
        // A list that is reloading, or was reloaded since, already shows the
        // server's state: the refusal is reported as it is.
        if (!isItemListed(item)) {
          keepCard();
          return null;
        }
        return readServerSaysNotShared(item).then(function (notShared) {
          if (notShared && isItemListed(item)) {
            showItemNotShared(item, button);
          } else {
            keepCard();
          }
        });
      });
    }

    function buildItemBinding(item) {
      return {
        productId: text(item.productId),
        productHandle: text(item.productHandle),
        templateLookup: text(item.templateLookup),
        templateTitle: text(item.templateTitle),
        selection: {
          selectedSizeId: text(item.selection && item.selection.selectedSizeId),
          selectedSizeLabel: text(item.selection && item.selection.selectedSizeLabel),
          selectedWidth: item.selection && item.selection.selectedWidth != null ? Number(item.selection.selectedWidth) : null,
          selectedHeight: item.selection && item.selection.selectedHeight != null ? Number(item.selection.selectedHeight) : null,
          selectedUnit: text(item.selection && item.selection.selectedUnit),
          selectedOrientation: text(item.selection && item.selection.selectedOrientation),
          size: text(item.selection && item.selection.size),
          unfoldedSize: text(item.selection && item.selection.unfoldedSize),
          backer: text(item.selection && item.selection.backer),
          optionSelections: item.selection && Array.isArray(item.selection.optionSelections)
            ? item.selection.optionSelections
            : []
        }
      };
    }

    function importLegacyItem(item) {
      return requestJson(proxyRoot + '/my-designs/import', {
        method: 'POST',
        headers: {
          accept: 'application/json',
          'content-type': 'application/json'
        },
        body: JSON.stringify({
          legacyProjectId: item.legacyProjectId,
          legacyDesignId: item.legacyDesignId,
          designNumber: item.designNumber,
          title: item.title,
          previewUrl: item.previewUrl,
          boardPreviews: item.boardPreviews,
          templateTitle: item.templateTitle,
          productId: item.productId,
          productHandle: item.productHandle,
          templateLookup: item.templateLookup,
          selection: item.selection
        })
      }).then(function (payload) {
        var detail = payload && payload.detail && typeof payload.detail === 'object' ? payload.detail : payload;
        return text(detail.lookup || detail.publicId || detail.projectId);
      });
    }

    function resolveCanonicalLookup(item) {
      if (item.sourceType !== 'legacy') {
        return Promise.resolve(text(item.lookup || item.publicId || item.projectId));
      }
      setNotice('Importing your legacy design…', '');
      return importLegacyItem(item).then(function (lookup) {
        if (!lookup) {
          throw new Error('Imported design lookup is unavailable.');
        }
        return lookup;
      });
    }

    function openEditorForItem(item, options) {
      var settings = options && typeof options === 'object' ? options : {};
      setNotice('', '');
      if (item.teamEditing) {
        setNotice(TEAM_EDITING_MESSAGE, '');
        return Promise.resolve(false);
      }
      // An unbound design has no product to open the editor under: choose
      // one first (the same picker Order uses), then launch.
      if (!item.hasOrderBinding || !text(item.productHandle)) {
        return openProductPicker(item, 'edit', settings.trigger, 'choose');
      }
      return resolveCanonicalLookup(item).then(function (lookup) {
        return editorShell.open({
          source: 'my-designs',
          storeKey: storeKey,
          projectId: lookup,
          productHandle: item.productHandle,
          productId: item.productId,
          designId: item.legacyDesignId,
          designNumber: item.designNumber,
          templateLookup: item.templateLookup,
          templateTitle: item.templateTitle,
          selectedOrientation: text(item.selection && item.selection.selectedOrientation),
          optionSelections: item.selection && Array.isArray(item.selection.optionSelections)
            ? item.selection.optionSelections
            : [],
          size: item.selection || {},
          storefrontBinding: buildItemBinding(item)
        });
      }).catch(function (error) {
        setNotice(String(error instanceof Error ? error.message : error), 'error');
        return false;
      });
    }

    // Today's Order behavior: the product page of the design's own product,
    // with the design loaded.
    function openItemProductPage(item) {
      setNotice('', '');
      return resolveCanonicalLookup(item).then(function (lookup) {
        var targetUrl = buildProductUrl(item.productHandle, lookup);
        if (!targetUrl) {
          throw new Error('Product binding is unavailable for this design.');
        }
        navigateTo(targetUrl);
        return true;
      }).catch(function (error) {
        setNotice(String(error instanceof Error ? error.message : error), 'error');
        return false;
      });
    }

    // MD-05: Order on a design that has a product opens the Order modal when
    // the design can also go on another product. With nothing else to offer
    // (or no product list), Order goes straight to the product page as before.
    function orderItem(item, options) {
      var settings = options && typeof options === 'object' ? options : {};
      if (!item.hasOrderBinding || !text(item.productHandle)) {
        return openProductPicker(item, 'order', settings.trigger, 'choose');
      }
      if (item.sourceType === 'legacy') return openItemProductPage(item);
      setNotice('', '');
      if (settings.trigger) settings.trigger.disabled = true;
      return loadChoosableProducts().catch(function () {
        return [];
      }).then(function (products) {
        if (settings.trigger) settings.trigger.disabled = false;
        var hasOtherProduct = buildProductModalSections(item, products, 'order').some(function (section) {
          return section.key !== 'original' && section.options.length > 0;
        });
        if (!hasOtherProduct) return openItemProductPage(item);
        return openProductPicker(item, 'order', settings.trigger, 'order');
      });
    }

    // MD-01: Duplicate makes a copy on the same product and size. The list
    // refreshes and the new card waits for its preview (MD-04).
    function duplicateItem(item, button) {
      setNotice('Making a copy…', '');
      if (button) button.disabled = true;
      return resolveCanonicalLookup(item).then(function (lookup) {
        return requestModalJson('/my-designs/copy-to-product', { projectId: lookup });
      }).then(function (payload) {
        var result = payload && payload.result && typeof payload.result === 'object' ? payload.result : {};
        var copyTitle = text(result.title) || ('Copy of ' + readDesignLabels(item).title);
        return loadLibrary('duplicate').then(function () {
          setNotice('“' + copyTitle + '” is in your designs.', 'success');
          return true;
        });
      }).catch(function (error) {
        if (button) button.disabled = false;
        setNotice(text(error && error.message) || 'The design could not be copied.', 'error');
        return false;
      });
    }

    // Product modal (MD-03, MD-05). One dialog serves "Choose Product" for an
    // unbound saved design and "Order" for a design that has a product (the
    // sectioned mode, see buildOrderModalSections). In Choose Product the
    // products that come in the design's size lead, each option shows the
    // product image, title and a size line, and a product without the
    // design's size asks for one of its own sizes first. The list is the
    // Admin's own configuration, read once per page visit. Choosing attaches
    // the product on the server, then continues with the action that opened
    // the modal: Order goes to that product's page with the design loaded,
    // Edit opens the editor under that product. A design placed on a size it
    // was not made at always opens in the editor first, so it is checked
    // before it is ordered.
    function loadChoosableProducts() {
      if (Array.isArray(state.products)) return Promise.resolve(state.products);
      if (state.productsPromise) return state.productsPromise;
      state.productsPromise = requestJson(proxyRoot + '/my-designs/products').then(function (payload) {
        var detail = payload && payload.detail && typeof payload.detail === 'object' ? payload.detail : {};
        state.products = (Array.isArray(detail.items) ? detail.items : []).map(normalizeProduct)
          .filter(function (product) { return !!product.handle; });
        return state.products;
      }).finally(function () {
        state.productsPromise = null;
      });
      return state.productsPromise;
    }

    function requestModalJson(path, body) {
      return fetch(proxyRoot + path, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { accept: 'application/json', 'content-type': 'application/json' },
        body: JSON.stringify(body)
      }).then(function (response) {
        return response.json().catch(function () { return null; }).then(function (payload) {
          if (response.status === 401 || text(payload && payload.error).toLowerCase() === 'login required') {
            redirectToLogin();
            throw new Error('Login required.');
          }
          if (!response.ok || !payload || payload.ok !== true) {
            var failure = new Error(text(payload && payload.error) || 'Request failed.');
            failure.code = text(payload && payload.code);
            failure.sizes = (Array.isArray(payload && payload.sizes) ? payload.sizes : []).map(normalizeProductSize).filter(Boolean);
            throw failure;
          }
          return payload;
        });
      });
    }

    function bindProductToItem(item, product, size) {
      return resolveCanonicalLookup(item).then(function (lookup) {
        var body = { projectId: lookup, productHandle: product.handle };
        if (size) body.sizeId = size.id;
        return requestModalJson('/my-designs/bind-product', body).then(function (payload) {
          var result = payload && payload.result && typeof payload.result === 'object' ? payload.result : {};
          var placedSize = normalizeProductSize(result.size);
          item.productHandle = text(result.productHandle) || product.handle;
          item.productId = text(result.productId) || product.productId;
          item.hasOrderBinding = true;
          if (placedSize) {
            item.selection.selectedSizeId = placedSize.id;
            item.selection.selectedSizeLabel = placedSize.label;
            item.selection.selectedWidth = placedSize.width;
            item.selection.selectedHeight = placedSize.height;
            item.selection.selectedUnit = placedSize.unit;
          }
          return lookup;
        });
      });
    }

    // Order sections (MD-05): the product the design was made for, other
    // products that come in the same size, then every other product whose
    // configuration lists sizes (the copy is resized to one of them). A copy
    // is offered only where the configuration allows one: neither the design's
    // own product nor the target may depend on a production layout or give
    // the canvas its own shape (a shaped design keeps its shape; a shaped
    // product needs a design started under it).
    function buildOrderModalSections(item, products) {
      var designSize = readDesignSize(item);
      var ownHandle = text(item.productHandle).toLowerCase();
      var ownProduct = products.find(function (product) { return product.handle === ownHandle; })
        || normalizeProduct({ productId: item.productId, handle: ownHandle });
      // The design's own flag decides first (it needs no product list); the
      // product list's flags cover a list item from an older storefront app.
      var copyAllowed = !item.hasProductSurface
        && ((ownProduct.acceptsCopies && !ownProduct.hasProductSurface)
          || !products.some(function (product) { return product.handle === ownHandle; }));
      var sameSize = [];
      var resize = [];
      products.forEach(function (product) {
        if (product.handle === ownHandle || !copyAllowed || !product.acceptsCopies || product.hasProductSurface) return;
        var fittingSize = findFittingSize(designSize, product);
        if (fittingSize) {
          sameSize.push({ product: product, action: 'copy', sizeLine: formatSizeLabel(fittingSize) });
        } else if (product.sizes.length) {
          resize.push({ product: product, action: 'copy-resize', sizeLine: summarizeProductSizes(product) });
        }
      });
      return [
        { key: 'original', heading: 'Made for this product', options: [{ product: ownProduct, action: 'open', sizeLine: formatSizeLabel(designSize) }] },
        { key: 'same-size', heading: 'Other products in this size', options: sameSize },
        { key: 'resize', heading: 'Other products', note: 'Copy and resize. You check the copy in the editor before you order.', options: resize }
      ];
    }

    // Choose Product sections: products that come in the design's size, then
    // every other offered product. A product is offered only when its surface
    // state matches the design: a plain design takes plain products (a shaped
    // product needs a design started under it); a shaped design takes only a
    // product with the same surface, and the list cannot tell which surface a
    // product carries, so it offers none (the server judges the exact surface
    // and refuses the rest). A product whose configuration needs its own
    // production layout is never offered. A section without options is not
    // rendered.
    function buildProductModalSections(item, products, mode) {
      if (mode === 'order') return buildOrderModalSections(item, products);
      var designSize = readDesignSize(item);
      var fits = [];
      var others = [];
      products.forEach(function (product) {
        if (!product.acceptsCopies || product.hasProductSurface || item.hasProductSurface) return;
        var fittingSize = findFittingSize(designSize, product);
        if (fittingSize) {
          fits.push({ product: product, action: 'bind', sizeLine: formatSizeLabel(fittingSize) });
        } else {
          others.push({
            product: product,
            action: designSize && product.sizes.length ? 'bind-size' : 'bind',
            sizeLine: summarizeProductSizes(product)
          });
        }
      });
      return [
        { key: 'fits', heading: 'Fits your design’s size', options: fits },
        { key: 'others', heading: fits.length ? 'Other products' : '', options: others }
      ];
    }

    function closeProductPicker(picker, trigger) {
      if (picker && picker.parentNode) picker.parentNode.removeChild(picker);
      document.removeEventListener('keydown', picker && picker.__bgOnKeydown || function () {});
      if (trigger && typeof trigger.focus === 'function') {
        try { trigger.focus(); } catch (_) {}
      }
    }

    function openProductPicker(item, intent, trigger, mode) {
      var modalMode = mode === 'order' ? 'order' : 'choose';
      setNotice('', '');
      var existing = document.querySelector('[data-bg-my-designs-picker]');
      if (existing) closeProductPicker(existing, null);
      var designSize = readDesignSize(item);
      var picker = document.createElement('div');
      picker.className = 'bg-account-my-designs__picker';
      picker.setAttribute('data-bg-my-designs-picker', '');
      picker.setAttribute('data-bg-picker-intent', text(intent) || 'order');
      picker.setAttribute('data-bg-picker-mode', modalMode);
      picker.innerHTML = '' +
        '<div class="bg-account-my-designs__picker-backdrop" data-bg-picker-close></div>' +
        '<div class="bg-account-my-designs__picker-panel" role="dialog" aria-modal="true" aria-labelledby="bg-my-designs-picker-title" tabindex="-1" data-bg-picker-panel>' +
          '<h2 class="bg-account-my-designs__picker-title" id="bg-my-designs-picker-title">' + (modalMode === 'order' ? 'Order “' : 'Choose a product for “') + escapeHtml(readDesignLabels(item).title) + '”</h2>' +
          (designSize ? '<p class="bg-account-my-designs__picker-copy" data-bg-picker-design-size>Your design: ' + escapeHtml(formatSizeLabel(designSize)) + '</p>' : '') +
          '<label class="bg-account-my-designs__picker-search" data-bg-picker-search-row>' +
            '<span class="visually-hidden">Search products</span>' +
            '<input type="search" placeholder="Search products" data-bg-picker-search autocomplete="off">' +
          '</label>' +
          '<div class="bg-account-my-designs__picker-status" data-bg-picker-status role="status" aria-live="polite">Loading products…</div>' +
          '<div class="bg-account-my-designs__picker-list" data-bg-picker-list></div>' +
          '<div class="bg-account-my-designs__picker-actions">' +
            '<button type="button" class="button button--secondary" data-bg-picker-back hidden>Back</button>' +
            '<button type="button" class="button button--secondary" data-bg-picker-close>Cancel</button>' +
          '</div>' +
        '</div>';
      document.body.appendChild(picker);
      var panel = picker.querySelector('[data-bg-picker-panel]');
      var searchRow = picker.querySelector('[data-bg-picker-search-row]');
      var searchInput = picker.querySelector('[data-bg-picker-search]');
      var statusNode = picker.querySelector('[data-bg-picker-status]');
      var listElement = picker.querySelector('[data-bg-picker-list]');
      var backButton = picker.querySelector('[data-bg-picker-back]');
      var busy = false;
      // The product whose sizes are on screen (the size step), else null.
      var sizeStep = null;

      function setPickerStatus(message, tone) {
        statusNode.textContent = text(message);
        statusNode.hidden = !text(message);
        statusNode.className = 'bg-account-my-designs__picker-status' + (tone ? (' is-' + tone) : '');
      }

      function setBusy(nextBusy) {
        busy = nextBusy;
        Array.prototype.slice.call(listElement.querySelectorAll('button')).forEach(function (node) { node.disabled = nextBusy; });
        backButton.disabled = nextBusy;
        // The pressed option is disabled now; keep focus inside the dialog.
        if (nextBusy) {
          try { panel.focus(); } catch (_) {}
        }
      }

      function watchThumbnails() {
        Array.prototype.slice.call(listElement.querySelectorAll('[data-bg-picker-thumb-image]')).forEach(function (image) {
          image.addEventListener('error', function () {
            if (image.parentNode) image.parentNode.removeChild(image);
          });
        });
      }

      function buildOptionMarkup(option, sectionKey) {
        var product = option.product;
        return '<button type="button" class="bg-account-my-designs__picker-option" data-bg-picker-option="' + escapeHtml(product.handle) + '" data-bg-picker-section="' + escapeHtml(sectionKey) + '" data-bg-picker-action="' + escapeHtml(option.action) + '">' +
          buildProductThumbMarkup(product) +
          '<span class="bg-account-my-designs__picker-option-text">' +
            '<span class="bg-account-my-designs__picker-option-title">' + escapeHtml(product.title) + '</span>' +
            (option.sizeLine ? '<span class="bg-account-my-designs__picker-option-size">' + escapeHtml(option.sizeLine) + '</span>' : '') +
          '</span>' +
        '</button>';
      }

      function renderProducts() {
        var products = Array.isArray(state.products) ? state.products : [];
        sizeStep = null;
        backButton.hidden = true;
        searchRow.hidden = false;
        if (!products.length && modalMode !== 'order') {
          listElement.innerHTML = '';
          setPickerStatus('No products are set up for saved designs yet.', 'error');
          return;
        }
        var query = text(searchInput.value).toLowerCase();
        var sections = buildProductModalSections(item, products, modalMode).map(function (section) {
          return {
            key: section.key,
            heading: section.heading,
            note: text(section.note),
            options: section.options.filter(function (option) {
              if (!query) return true;
              return (option.product.title + ' ' + option.product.handle).toLowerCase().indexOf(query) !== -1;
            })
          };
        }).filter(function (section) { return section.options.length > 0; });
        setPickerStatus('', '');
        if (!sections.length) {
          listElement.innerHTML = '<p class="bg-account-my-designs__picker-empty">' + (!query && item.hasProductSurface
            ? 'This design was made for a shaped product, so it cannot be placed on another product.'
            : 'No products match that search.') + '</p>';
          return;
        }
        listElement.innerHTML = sections.map(function (section) {
          var headingId = 'bg-my-designs-picker-section-' + section.key;
          return '<section class="bg-account-my-designs__picker-section" data-bg-picker-section-group="' + escapeHtml(section.key) + '"' + (section.heading ? ' aria-labelledby="' + headingId + '"' : ' aria-label="Products"') + '>' +
            (section.heading ? '<h3 class="bg-account-my-designs__picker-section-title" id="' + headingId + '">' + escapeHtml(section.heading) + '</h3>' : '') +
            (section.note ? '<p class="bg-account-my-designs__picker-section-note" data-bg-picker-section-note>' + escapeHtml(section.note) + '</p>' : '') +
            section.options.map(function (option) { return buildOptionMarkup(option, section.key); }).join('') +
          '</section>';
        }).join('');
        watchThumbnails();
      }

      // The size step: the product does not come in the design's size, so the
      // customer picks one of the product's own sizes.
      function renderSizeStep(product, sizes, message) {
        sizeStep = { product: product, sizes: sizes };
        backButton.hidden = false;
        searchRow.hidden = true;
        setPickerStatus(message || '“' + product.title + '” does not come in your design’s size. Choose one of its sizes.', '');
        listElement.innerHTML = '<section class="bg-account-my-designs__picker-section" data-bg-picker-size-step aria-label="Sizes for ' + escapeHtml(product.title) + '">' +
          sizes.map(function (size) {
            return '<button type="button" class="bg-account-my-designs__picker-option" data-bg-picker-size="' + escapeHtml(size.id) + '">' +
              '<span class="bg-account-my-designs__picker-option-text"><span class="bg-account-my-designs__picker-option-title">' + escapeHtml(formatSizeLabel(size)) + '</span></span>' +
            '</button>';
          }).join('') +
        '</section>';
        var firstSize = listElement.querySelector('[data-bg-picker-size]');
        if (firstSize) {
          try { firstSize.focus(); } catch (_) {}
        }
      }

      function attachProduct(product, size) {
        setBusy(true);
        setPickerStatus('Attaching “' + product.title + '”…', '');
        bindProductToItem(item, product, size).then(function (lookup) {
          closeProductPicker(picker, null);
          renderItems();
          // A size the design was not made at is checked in the editor first.
          if (intent === 'edit' || size) {
            return openEditorForItem(item, { trigger: trigger });
          }
          var targetUrl = buildProductUrl(item.productHandle, lookup);
          if (!targetUrl) throw new Error('Product binding is unavailable for this design.');
          setNotice('Opening ' + product.title + ' with your design…', '');
          navigateTo(targetUrl);
          return true;
        }).catch(function (error) {
          setBusy(false);
          // The server found no size for the design on this product: ask for one.
          if (error && error.code === 'BIND_SIZE_REQUIRED' && !size) {
            var sizes = error.sizes && error.sizes.length ? error.sizes : product.sizes;
            if (sizes.length) {
              renderSizeStep(product, sizes, text(error.message));
              return;
            }
          }
          setPickerStatus(text(error && error.message) || 'The product could not be attached to this design.', 'error');
        });
      }

      // MD-05 (a): the design's own product keeps today's Order behavior.
      function openOwnProduct() {
        closeProductPicker(picker, null);
        return openItemProductPage(item);
      }

      // MD-05 (b) and (c): place a copy on another product. The original
      // design is never changed. Order continues on that product's page with
      // the copy loaded; Edit, and any copy the server resized, opens the
      // editor so the customer checks it before ordering.
      function copyToProduct(product, resizing) {
        setBusy(true);
        setPickerStatus((resizing ? 'Copying and resizing your design for “' : 'Copying your design to “') + product.title + '”…', '');
        resolveCanonicalLookup(item).then(function (lookup) {
          return requestModalJson('/my-designs/copy-to-product', { projectId: lookup, productHandle: product.handle });
        }).then(function (payload) {
          var result = payload && payload.result && typeof payload.result === 'object' ? payload.result : {};
          var copyLookup = text(result.publicId || result.projectId);
          if (!copyLookup) throw new Error('The design could not be copied.');
          var placedSize = normalizeProductSize(result.size);
          var copyItem = normalizeItem({
            id: copyLookup,
            lookup: copyLookup,
            projectId: text(result.projectId),
            publicId: text(result.publicId),
            title: text(result.title) || ('Copy of ' + readDesignLabels(item).title),
            productId: text(result.productId) || product.productId,
            productHandle: text(result.productHandle) || product.handle,
            hasOrderBinding: true,
            templateLookup: item.templateLookup,
            templateTitle: item.templateTitle,
            selection: placedSize ? {
              selectedSizeId: placedSize.id,
              selectedSizeLabel: placedSize.label,
              selectedWidth: placedSize.width,
              selectedHeight: placedSize.height,
              selectedUnit: placedSize.unit
            } : {}
          });
          closeProductPicker(picker, null);
          if (intent === 'edit' || result.resized === true) {
            return openEditorForItem(copyItem, { trigger: trigger });
          }
          var targetUrl = buildProductUrl(copyItem.productHandle, copyLookup);
          if (!targetUrl) throw new Error('The design could not be copied.');
          setNotice('Opening ' + product.title + ' with a copy of your design…', '');
          navigateTo(targetUrl);
          return true;
        }).catch(function (error) {
          if (!picker.parentNode) {
            setNotice(text(error && error.message) || 'The design could not be copied.', 'error');
            return;
          }
          setBusy(false);
          setPickerStatus(text(error && error.message) || 'The design could not be copied.', 'error');
        });
      }

      function focusableNodes() {
        return Array.prototype.slice.call(panel.querySelectorAll('button, input, [href], [tabindex]:not([tabindex="-1"])')).filter(function (node) {
          return !node.disabled && !node.hidden && !(node.closest && node.closest('[hidden]'));
        });
      }

      picker.__bgOnKeydown = function (event) {
        // Like Cancel: a running bind keeps the picker until the server answers.
        if (event.key === 'Escape') {
          if (!busy) closeProductPicker(picker, trigger);
          return;
        }
        if (event.key !== 'Tab') return;
        // Focus trap: Tab and Shift+Tab stay inside the dialog.
        var nodes = focusableNodes();
        if (!nodes.length) {
          event.preventDefault();
          try { panel.focus(); } catch (_) {}
          return;
        }
        var first = nodes[0];
        var last = nodes[nodes.length - 1];
        var active = document.activeElement;
        var inside = active && panel.contains(active) && active !== panel;
        if (event.shiftKey && (!inside || active === first)) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && (!inside || active === last)) {
          event.preventDefault();
          first.focus();
        }
      };
      document.addEventListener('keydown', picker.__bgOnKeydown);
      Array.prototype.slice.call(picker.querySelectorAll('[data-bg-picker-close]')).forEach(function (node) {
        node.addEventListener('click', function () {
          if (busy) return;
          closeProductPicker(picker, trigger);
        });
      });
      backButton.addEventListener('click', function () {
        if (busy) return;
        renderProducts();
        try { searchInput.focus(); } catch (_) {}
      });
      searchInput.addEventListener('input', function () {
        if (Array.isArray(state.products)) renderProducts();
      });
      listElement.addEventListener('click', function (event) {
        if (busy || !event.target || !event.target.closest) return;
        var sizeNode = event.target.closest('[data-bg-picker-size]');
        if (sizeNode && sizeStep) {
          var sizeId = text(sizeNode.getAttribute('data-bg-picker-size'));
          var pickedSize = sizeStep.sizes.find(function (entry) { return entry.id === sizeId; });
          if (pickedSize) attachProduct(sizeStep.product, pickedSize);
          return;
        }
        var option = event.target.closest('[data-bg-picker-option]');
        if (!option) return;
        var handle = text(option.getAttribute('data-bg-picker-option'));
        var product = (state.products || []).find(function (entry) { return entry.handle === handle; });
        // The design's own product stays orderable when it is not in the list.
        if (!product && handle === text(item.productHandle).toLowerCase()) {
          product = normalizeProduct({ productId: item.productId, handle: handle });
        }
        if (!product) return;
        var action = text(option.getAttribute('data-bg-picker-action'));
        if (action === 'open') {
          void openOwnProduct();
        } else if (action === 'copy' || action === 'copy-resize') {
          copyToProduct(product, action === 'copy-resize');
        } else if (action === 'bind-size') {
          renderSizeStep(product, product.sizes, '');
        } else {
          attachProduct(product, null);
        }
      });

      try { searchInput.focus(); } catch (_) {}
      return loadChoosableProducts().then(function () {
        renderProducts();
        return true;
      }).catch(function (error) {
        setPickerStatus(text(error && error.message) || 'Product choices are unavailable right now.', 'error');
        return false;
      });
    }

    // MD-04: preview polling. Runs only while a listed card is waiting for
    // its preview. Each list load starts a fresh wait with one wall-clock
    // deadline; a poll asks for the same page, patches only the cards whose
    // preview arrived (the list is never re-rendered, so focus and scroll stay
    // put) and always uses the freshly signed URL from its own response,
    // because signed preview URLs expire within minutes. A request that runs
    // past its own limit is abandoned, so a stalled request cannot hold the
    // wait open. At the deadline the waiting cards fall back to "Preview
    // unavailable". A hidden tab sends nothing; every return to a visible tab
    // polls at once, and a return after the deadline checks one last time.
    var previewPoll = { episode: 0, timer: 0, deadlineTimer: 0, deadlineAt: 0, attempt: 0, inFlight: false, pausedHidden: false, cancelRequest: null };

    function hasPendingPreview() {
      return state.items.some(function (item) { return item.previewPending; });
    }

    function isPageHidden() {
      return document.hidden === true || document.visibilityState === 'hidden';
    }

    function patchPreviewCard(item) {
      if (!listNode) return;
      var cards = listNode.querySelectorAll('[data-bg-my-design-id]');
      for (var index = 0; index < cards.length; index += 1) {
        if (text(cards[index].getAttribute('data-bg-my-design-id')) !== item.id) continue;
        var previewNode = cards[index].querySelector('.bg-account-my-designs__preview');
        if (!previewNode) return;
        if (text(item.mockupPoster && item.mockupPoster.url)) {
          previewNode.setAttribute('data-bg-mockup-poster', 'true');
        } else {
          previewNode.removeAttribute('data-bg-mockup-poster');
        }
        previewNode.innerHTML = buildPreviewMarkup(item);
        return;
      }
    }

    // The one place a wait ends: every timer and the in-flight request stop,
    // and the episode number makes any late answer from that wait a no-op.
    function stopPreviewPolling() {
      previewPoll.episode += 1;
      window.clearTimeout(previewPoll.timer);
      window.clearTimeout(previewPoll.deadlineTimer);
      previewPoll.timer = 0;
      previewPoll.deadlineTimer = 0;
      previewPoll.deadlineAt = 0;
      if (previewPoll.cancelRequest) previewPoll.cancelRequest();
      previewPoll.cancelRequest = null;
      previewPoll.inFlight = false;
      previewPoll.pausedHidden = false;
    }

    function endPreviewPollingBudget() {
      stopPreviewPolling();
      state.items.forEach(function (item) {
        if (!item.previewPending) return;
        item.previewPending = false;
        patchPreviewCard(item);
      });
    }

    function applyPreviewPollItems(polledItems) {
      var polledById = {};
      polledItems.forEach(function (polled) { polledById[polled.id] = polled; });
      state.items.forEach(function (item) {
        if (!item.previewPending) return;
        var polled = polledById[item.id];
        // Gone from this page, or the api stopped reporting it as pending.
        if (polled && polled.previewPending) return;
        item.previewPending = false;
        if (polled) {
          item.previewUrl = polled.previewUrl;
          item.boardPreviews = polled.boardPreviews;
          item.mockupPoster = polled.mockupPoster;
        }
        patchPreviewCard(item);
      });
    }

    function schedulePreviewPoll() {
      window.clearTimeout(previewPoll.timer);
      previewPoll.timer = 0;
      if (!hasPendingPreview()) {
        stopPreviewPolling();
        return;
      }
      if (isPageHidden()) {
        previewPoll.pausedHidden = true;
        return;
      }
      var delay = previewPollDelay(previewPoll.attempt);
      if (Date.now() + delay > previewPoll.deadlineAt) {
        // No poll starts past the deadline. The deadline timer ends the wait;
        // when it already fired while the tab was hidden, the wait ends here.
        if (!previewPoll.deadlineTimer) endPreviewPollingBudget();
        return;
      }
      var episode = previewPoll.episode;
      previewPoll.timer = window.setTimeout(function () {
        previewPoll.timer = 0;
        if (episode !== previewPoll.episode) return;
        previewPoll.attempt += 1;
        runPreviewPoll(false);
      }, delay);
    }

    function runPreviewPoll(lastCheck) {
      if (previewPoll.inFlight || state.loading) return;
      if (isPageHidden()) {
        previewPoll.pausedHidden = true;
        return;
      }
      var episode = previewPoll.episode;
      var controller = typeof AbortController === 'function' ? new AbortController() : null;
      var settled = false;
      var requestTimer = 0;
      function finish(payload) {
        if (settled) return;
        settled = true;
        window.clearTimeout(requestTimer);
        if (episode !== previewPoll.episode) return;
        previewPoll.inFlight = false;
        previewPoll.cancelRequest = null;
        if (payload && payload.signedOut) {
          // Signed out in another tab: stop quietly, the next action asks for login.
          endPreviewPollingBudget();
          return;
        }
        var detail = payload && payload.ok === true && payload.detail && typeof payload.detail === 'object' ? payload.detail : null;
        if (detail && Array.isArray(detail.items)) {
          applyPreviewPollItems(detail.items.map(normalizeItem));
        }
        if (lastCheck) {
          endPreviewPollingBudget();
          return;
        }
        schedulePreviewPoll();
      }
      previewPoll.inFlight = true;
      previewPoll.cancelRequest = function () {
        settled = true;
        window.clearTimeout(requestTimer);
        if (controller) {
          try { controller.abort(); } catch (_) {}
        }
      };
      // A stalled request is abandoned (and aborted where the browser can):
      // it counts as a failed poll and the wait carries on.
      requestTimer = window.setTimeout(function () {
        if (controller) {
          try { controller.abort(); } catch (_) {}
        }
        finish(null);
      }, PREVIEW_POLL_REQUEST_TIMEOUT_MS);
      var requestOptions = { credentials: 'same-origin', headers: { accept: 'application/json' } };
      if (controller) requestOptions.signal = controller.signal;
      fetch(buildLibraryRequestUrl(), requestOptions).then(function (response) {
        if (response.status === 401) return { signedOut: true };
        return response.json().catch(function () { return null; });
      }).catch(function () {
        return null;
      }).then(finish);
    }

    function startPreviewPolling() {
      stopPreviewPolling();
      previewPoll.attempt = 0;
      if (!hasPendingPreview()) return;
      var episode = previewPoll.episode;
      previewPoll.deadlineAt = Date.now() + PREVIEW_POLL_BUDGET_MS;
      previewPoll.deadlineTimer = window.setTimeout(function () {
        previewPoll.deadlineTimer = 0;
        if (episode !== previewPoll.episode) return;
        if (isPageHidden()) {
          // Nobody is looking: the return to a visible tab checks one last time.
          window.clearTimeout(previewPoll.timer);
          previewPoll.timer = 0;
          previewPoll.pausedHidden = true;
          return;
        }
        endPreviewPollingBudget();
      }, PREVIEW_POLL_BUDGET_MS);
      schedulePreviewPoll();
    }

    document.addEventListener('visibilitychange', function () {
      if (isPageHidden()) {
        if (previewPoll.timer) {
          window.clearTimeout(previewPoll.timer);
          previewPoll.timer = 0;
          previewPoll.pausedHidden = true;
        }
        return;
      }
      if (!previewPoll.pausedHidden) return;
      previewPoll.pausedHidden = false;
      if (!hasPendingPreview()) {
        stopPreviewPolling();
        return;
      }
      // Every return polls at once. Past the deadline it is the last check.
      runPreviewPoll(Date.now() >= previewPoll.deadlineAt);
    });

    function buildLibraryRequestUrl() {
      var requestUrl = new URL(proxyRoot + '/my-designs', window.location.origin);
      requestUrl.searchParams.set('limit', String(state.limit));
      requestUrl.searchParams.set('offset', String(state.offset));
      if (text(state.query)) requestUrl.searchParams.set('query', state.query);
      return requestUrl.toString();
    }

    function loadLibrary(reason) {
      stopPreviewPolling();
      state.loading = true;
      renderItems();
      setNotice('', '');
      return requestJson(buildLibraryRequestUrl()).then(function (payload) {
        var detail = payload && payload.detail && typeof payload.detail === 'object' ? payload.detail : {};
        state.items = Array.isArray(detail.items) ? detail.items.map(normalizeItem) : [];
        state.party = detail.party && typeof detail.party === 'object' ? detail.party : null;
        state.total = Number(detail.total) || state.items.length;
        renderSummary(detail);
        renderItems();
        renderPagination();
        if (reason && ['manual-refresh', 'editor-save', 'editor-close', 'claim-queue-flush', 'refresh'].indexOf(reason) !== -1) {
          setNotice('Saved designs refreshed.', '');
          window.setTimeout(function () {
            if (text(noticeNode && noticeNode.textContent) === 'Saved designs refreshed.') {
              setNotice('', '');
            }
          }, 1800);
        }
      }).catch(function (error) {
        state.items = [];
        state.total = 0;
        renderSummary({ total: 0, serviceAssignments: [], party: state.party });
        renderItems();
        renderPagination();
        setNotice(String(error instanceof Error ? error.message : error), 'error');
      }).finally(function () {
        state.loading = false;
        renderItems();
        startPreviewPolling();
      });
    }

    if (searchInput) {
      searchInput.addEventListener('input', function () {
        window.clearTimeout(searchTimer);
        searchTimer = window.setTimeout(function () {
          state.query = text(searchInput.value);
          state.offset = 0;
          void loadLibrary('search');
        }, 220);
      });
    }

    if (refreshButton) {
      refreshButton.addEventListener('click', function () {
        void loadLibrary('manual-refresh');
      });
    }

    // Arrival from a shared design's "Use this design": the copy is already
    // in the list; say so once and drop the marker from the address bar.
    try {
      var arrivalUrl = new URL(window.location.href);
      if (text(arrivalUrl.searchParams.get('bg_copied'))) {
        arrivalUrl.searchParams.delete('bg_copied');
        window.history.replaceState({}, document.title, arrivalUrl.toString());
        window.setTimeout(function () {
          setNotice('Your copy is in your designs. Choose Edit to make it yours, or Choose Product to order it.', 'success');
        }, 0);
      }
    } catch (_) {}

    void loadLibrary('initial');

    return {
      refresh: function (reason) {
        return loadLibrary(text(reason) || 'refresh');
      }
    };
  }

  document.addEventListener('DOMContentLoaded', function () {
    var root = document.querySelector('[data-bg-self-hosted-my-designs-root]');
    if (!root) return;
    var controller = initRoot(root);
    window.BGSelfHostedMyDesigns = controller || {
      refresh: function () {
        return Promise.resolve(false);
      }
    };
  });
})();
